import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-sm flex-col justify-center gap-4 px-4 text-center">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <Link to="/" className="font-medium text-brand underline-offset-2 hover:underline">
        Go home
      </Link>
    </main>
  );
}
